import { useFlags } from 'launchdarkly-react-client-sdk';
import { useCallback } from 'react';
import { useAiV2Enabled } from 'src/hooks/useAiV2Enabled';
import { isChatHostPath } from 'src/routing/chatHostPaths';

// Path prefixes locked users may reach. Match is exact equality OR `prefix + '/'`, so `/ai-inbox` matches `/ai-inbox/42` but NOT `/ai-inbox-archive`.
export const ALLOWED_PATH_PREFIXES = ['/ai-inbox', '/document-onboardings', '/user-profile'] as const;

export function isAllowedPath(pathname: string): boolean {
  return ALLOWED_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

interface AiInboxOnlyMode {
  locked: boolean;
  isAllowedPath: (pathname: string) => boolean;
}

export function useAiInboxOnlyMode(): AiInboxOnlyMode {
  const flags = useFlags();
  const aiV2 = useAiV2Enabled();
  const locked = Boolean(flags.aiInboxOnly);

  // Stable reference so consumers can pass this directly into useEffect deps
  // without churning the effect on every render.
  const check = useCallback(
    (pathname: string) => isAllowedPath(pathname) || (aiV2 && isChatHostPath(pathname)),
    [aiV2]
  );

  return { locked, isAllowedPath: check };
}
